import { apiClient } from '@/api/client'
import type { UserListItem } from './types'

export async function fetchUsers(): Promise<UserListItem[]> {
  const { data } = await apiClient.get<UserListItem[]>('/portal/users/api/v2/users')
  return data
}

export async function fetchUser(userId: string): Promise<UserListItem> {
  const { data } = await apiClient.get<UserListItem>(`/portal/users/api/v2/${userId}`)
  return data
}

/** Self-service equivalent of fetchUser/updateUserProfile that works for
 * every authenticated role, not just users.view/users.manage holders -
 * backs ProfilePage, reachable from the header for any logged-in user. */
export async function fetchMyProfile(): Promise<UserListItem> {
  const { data } = await apiClient.get<UserListItem>('/portal/users/api/v2/me')
  return data
}

export async function updateMyProfile(fields: {
  firstname: string
  lastname: string
  phone: string
  password?: string
}): Promise<UserListItem> {
  const { data } = await apiClient.post<UserListItem>('/portal/users/update/me', fields)
  return data
}

export async function updateUserProfile(
  userId: string,
  fields: { firstname: string; lastname: string; phone: string; company_name?: string; password?: string },
): Promise<UserListItem> {
  const { data } = await apiClient.post<UserListItem>(`/portal/users/update/${userId}`, fields)
  return data
}

export async function updateUserPrivileges(
  userId: string,
  privileges: { is_admin: boolean; is_super_user: boolean; is_staff: boolean; is_client: boolean },
): Promise<UserListItem> {
  const { data } = await apiClient.post<UserListItem>(`/portal/users/update/${userId}/privileges`, privileges)
  return data
}

export async function deleteUser(userId: string): Promise<void> {
  await apiClient.post(`/portal/users/delete/${userId}`)
}

export async function updateUserRole(userId: string, role: 'admin' | 'staff' | 'client'): Promise<void> {
  await apiClient.post(`/portal/users/api/update-role/${userId}`, { role })
}
